/* eslint-disable max-len */
import ComunidadesRuraisTradicionaisAPI from 'api/forms/comunidades_rurais_tradicionais';
import { FormularioComunidades } from 'interfaces/formularioComunidades.interface';
import { create } from 'zustand';

export interface IComunidadesRuraisTradicionais {
    uuid: string
    createdAt: string
    updatedAt: string
    deletedAt: any
    pacote_status: number
    step_atual: number
    institution_uuid: string

    // Step 1
    ano_referencia_do_questionario: number | null
    tipo_cadastro: number | null
    tipo_de_assentamento: number | null
    codigo_do_pa: number | null
    nome_do_assentamento: string | null
    quantidade_de_familias: number | null

    // Step 2
    possui_energia_eletrica: boolean | null
    possui_saneamento_basico: boolean | null
    coleta_de_lixo: boolean | null
    recebeu_manutencao_das_estradas_no_ultimo_ano: boolean | null
    possui_escolas: boolean | null
    escola_json: Array<Array<{ jurisdicao: string; nome: string }>> | null
    possui_oferta_de_transporte_escolar_para_os_estudantes: boolean | null
    possui_unidade_de_saude: boolean | null
    recebeu_agentes_de_saude_do_municipio: boolean | null

    // Step 3
    possui_agua_para_abastecimento_domestico: boolean | null
    qual_fonte_da_agua_domestico: number | null
    possui_agua_para_producao_agropecuaria: boolean | null
    qual_fonte_da_producao_agropecuaria: number | null
    quantas_familia_estao_sem_acesso_agua_domestico: number | null
    quantas_familia_estao_sem_acesso_agua_producao: number | null
    comunidade_quilomba_tem_dificil_acesso_agua_domestico: boolean | null
    comunidade_quilomba_tem_dificil_acesso_agua_producao: boolean | null
    tem_acesso_internet: boolean | null

    created_by: string
    updated_by: string
    deleted_by: any
    pacote_formularios_uuid: string

    // NOVO MODELO
    assentamentos: Array<FormularioComunidades>
    comunidades: Array<FormularioComunidades>
}

export interface IComunidadesRuraisTradicionaisStore {
    comunidadesRuraisTradicionais: IComunidadesRuraisTradicionais,
    loading: boolean,
    setComunidadesRuraisTradicionais: (comunidadesRuraisTradicionais: IComunidadesRuraisTradicionais) => void
    getComunidadesRuraisTradicionais: (uuid: string) => Promise<void>,
    setPartialForm: (chave: keyof IComunidadesRuraisTradicionais, valor: any) => void,
    setLoading: (loading: boolean) => void,
    saveDraftForm: () => Promise<boolean>,
    enviarAprovacao: () => Promise<boolean>
}

const useComunidadesRuraisTradicionaisStore = create<IComunidadesRuraisTradicionaisStore>((set, get) => ({
    comunidadesRuraisTradicionais: {} as IComunidadesRuraisTradicionais,
    loading: true,
    setComunidadesRuraisTradicionais: (comunidadesRuraisTradicionais: IComunidadesRuraisTradicionais) => set({ comunidadesRuraisTradicionais }),
    getComunidadesRuraisTradicionais: async (uuid: string) => {
        const response = await ComunidadesRuraisTradicionaisAPI.getByUUID(uuid);
        set({ comunidadesRuraisTradicionais: response.dados });
        set({ loading: false });
        return response.dados;
    },
    setPartialForm: (chave: keyof IComunidadesRuraisTradicionais, valor: any) => {
        set((state) => ({
            comunidadesRuraisTradicionais: {
                ...state.comunidadesRuraisTradicionais,
                [chave]: valor
            }
        }))
    },
    setLoading: (loading: boolean) => set({ loading }),
    saveDraftForm: async () => {
        const response = await ComunidadesRuraisTradicionaisAPI.update(get().comunidadesRuraisTradicionais.uuid, get().comunidadesRuraisTradicionais);
        if (response.Status === 'OK') {
            return true;
        }
        return false;
    },
    enviarAprovacao: async () => {
        const formulario = get().comunidadesRuraisTradicionais!;
        formulario.pacote_status = 3;
        const response = await ComunidadesRuraisTradicionaisAPI.update(get().comunidadesRuraisTradicionais.uuid, formulario);
        if (response.Status === 'OK') {
            return true;
        }
        return false;
    }
}));

export default useComunidadesRuraisTradicionaisStore;